import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-featured-services',
  templateUrl: './featured-services.component.html'
})
export class FeaturedServicesComponent implements OnInit {

  featuredServicesList: any = [];

  constructor() {
    this.featuredServicesList.push(new FeaturedServices('COMPRAS', 'Si no contas con una tarjeta de crédito para tus compras #HaceloFácil, acercate a nosotros y realizamos la compra por vos.','', '', 'assets/compras.png'));
    this.featuredServicesList.push(new FeaturedServices('ENVÍOS AÉREOS', 'Trae tus compras de manera segura, rápida y confiable al mejor precio.','','','assets/avion.png' ));
    this.featuredServicesList.push(new FeaturedServices('ENVÍOS MARÍTIMOS', '¿Buscas una tarifa conveniente?', '¡Con HomeBox olvidate de pagar costos elevados! Cotizamos tus envíos al precio justo.','', 'assets/barco.png'));
  }

  ngOnInit() { }

}

class FeaturedServices {
  titulo: string;
  descripcionLinea1: string;
  descripcionLinea2: string;
  descripcionLinea3: string;
  imagen: string

  constructor(titulo: string, descripcionLinea1: string, descripcionLinea2: string, descripcionLinea3: string, imagen: string) {
    this.titulo = titulo;
    this.descripcionLinea1 = descripcionLinea1;
    this.descripcionLinea2 = descripcionLinea2;
    this.descripcionLinea3 = descripcionLinea3;
    this.imagen = imagen;
  }
}